// extracted by mini-css-extract-plugin
export default {"AboutUs":"AboutUs_AboutUs__u9YJw","logo":"AboutUs_logo__r3X1B"};